import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-alert-ignorar-erros',
    templateUrl: './alert-ignorar-erros.component.html',
    styleUrls: ['./alert-ignorar-erros.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertIgnorarErrosComponent {
  @Output() fecharAlertIgnorarErros = new EventEmitter();
  @Input() alertIgnorarErros: boolean;

  constructor() { }

  alertAlertIgnorarErrosFechou() {
    this.fecharAlertIgnorarErros.emit('Fechou');
  }


}
